<div class="flex flex-column gap-6">
  @if (!isSubmitting()) {
    <p class="font-normal">
      {{
        email.isMerge
          ? ('home.confirmEmail.merge.descriptionPrefix' | translate)
          : ('home.confirmEmail.add.descriptionPrefix' | translate)
      }}
      <span class="inline font-bold">{{ email.emailAddress }}</span>
      {{
        email.isMerge
          ? ('home.confirmEmail.merge.descriptionSuffix' | translate)
          : ('home.confirmEmail.add.descriptionSuffix' | translate)
      }}
    </p>

    <div class="flex w-full justify-content-center gap-2">
      <p-button
        severity="info"
        class="w-full"
        styleClass="w-full"
        (onClick)="closeDialog()"
        [label]="'common.buttons.cancel' | translate"
      ></p-button>

      <p-button
        class="w-full"
        styleClass="w-full"
        (onClick)="verifyEmail()"
        [label]="
          email.isMerge
            ? ('home.confirmEmail.merge.goToEmails' | translate)
            : ('home.confirmEmail.add.goToEmails' | translate)
        "
      ></p-button>
    </div>
  } @else {
    <osf-loading-spinner></osf-loading-spinner>
  }
</div>
